import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ElementRef, NgZone } from '@angular/core';
import { TranslateService, DefaultLangChangeEvent } from '@ngx-translate/core';
import { NgForm, FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationProvider } from 'src/app/providers/authentication/authentication';
import { CoreProvider } from 'src/app/providers/core/core.service';
import { DamagesProvider } from 'src/app/providers/damages/damage';
import { Events, Platform, ActionSheetController, IonSlides, PopoverController, ToastController } from '@ionic/angular';
import { Camera } from '@ionic-native/camera/ngx';
import { ModalController } from '@ionic/angular';
import { OwlDateTimeComponent } from 'ng-pick-datetime';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { environment } from 'src/environments/environment';
import { Tenant } from 'src/app/enums/tenant';
import { QuestionsPopoverPage } from 'src/app/pages/questions-popover/questions-popover.page';
import { CaptchaModalComponent } from '../captcha-modal/captcha-modal.component';
import { noWhitespaceValidator } from 'src/app/validators/no-whitespace.validtor'


@Component({
  selector: 'report-damage',
  templateUrl: './report-damage.component.html',
  styleUrls: ['./report-damage.component.scss'],
})
export class ReportDamageComponent implements OnInit, OnDestroy {
  customDatetimeOptions = {
    cssClass: 'datetime-bg-color'
  };
  @ViewChild('dtPicker', { static: false }) dtPicker1: OwlDateTimeComponent<any>;
  isApp: boolean;
  isMobileApp: boolean;
  browserName: any;
  recaptchaKey = environment.recaptcha.siteKey;
  captchaResolved = false;

  /*---------------------------------------------------------------------*/
  constructor(public translate: TranslateService, public router: Router,
    private coreService: CoreProvider, private damageService: DamagesProvider,
    private authenticationService: AuthenticationProvider, private events: Events,
    public camera: Camera, public platform: Platform, private route: ActivatedRoute,
    public actionSheetCtrl: ActionSheetController, private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef,
    dateTimeAdapter: DateTimeAdapter<any>,
    public modalCtrl: ModalController,
    private elementRef: ElementRef,
    public popoverController: PopoverController,
    public toastController: ToastController) {
    dateTimeAdapter.setLocale('de-DE');
    route.params.subscribe(val => {
      this.isApp = this.platform.is('cordova');
      this.isBrowser = this.platform.is('mobileweb');
      this.isLoggedInUser = this.authenticationService.currentUserData() ? true : false;
      if (this.isLoggedInUser) {
        this.userData = JSON.parse(localStorage.getItem('meData'));
      } else {
        this.userData = null;
      }
    });
    this.events.subscribe('assetData', async (data) => {
      if (data) {
        this.assetData = data;
        if (this.damageModel && this.damageModel.vehicle) {
          await this.setVehicleFormData();
        }
      }
    });

    if (environment.tenant === Tenant.Santander) {
      this.isSantander = 'true';
    }
    else {
      this.isSantander = 'false';
    }
  }
  categories: any;
  reportTypeDamage: any;
  reportObjectDamage: any;
  drsegment: any;
  selectedTab: any;
  damageModel: any;
  kfzModel: any;
  anotherKfzModel: any;
  bicyclePedestrainModel: any;
  thirdPartyModel: any;
  countryNames: any;
  drivingLicenseClass: any;
  /*---------------------------------------------------------------------*/
  imageBase64: { filename: string; base64Data: string }[] = [];
  selectedItem: any;
  selectedItemType: any;
  assetsList: any;
  currentAssetId: string;
  isThing = false;
  isPerson = false;
  selDate: any;
  isType = false;
  clickedImages: any[];
  selTime: any;
  isMaster = false;
  isInvalidFileType = false;
  isInvalidFileSize = false;
  invalidTypeName: string;
  invalidSizeName: string;
  employeePhone: string;
  employeeEmail: string;
  previousTabName: any;
  // tslint:disable-next-line: max-line-length
  emailValidator = /^((([a-z]|[A-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|[A-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|[A-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[A-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|[A-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[A-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[A-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[A-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|[A-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[A-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/;
  vinValidator = /^[a-hA-Hj-nJ-NpPr-zR-Z0-9]{17}$/;
  // phoneValidator = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
  // phoneValidator = /^(\+\s?)?((?<!\+.*)\(\+?\d+([\s\-\.]?\d+)?\)|\d+)([\s\-\.]?(\(\d+([\s\-\.]?\d+)?\)|\d+))*(\s?(x|ext\.?)\s?\d+)?$/;
  phoneValidator = /^((\+?[\s\d\-]{1,30})|((\+?[\s\d\-]{1,30})(x|ext)([\s\d\-]{1,30})))$/;
  euromasterFormGroup: FormGroup;
  damageFormGroup: FormGroup;
  driverFormGroup: FormGroup;
  vehicleFormGroup: FormGroup;
  policeFormGroup: FormGroup;
  otherPartyFormGroup: FormGroup;
  ownerFormGroup: FormGroup;
  kfzFormGroup: FormGroup;
  anotherKfzFormGroup: FormGroup;
  bicyclePedestrainFormGroup: FormGroup;
  thirdPartyDamage: FormGroup;
  language: string;
  isLoggedInUser = false;
  selectedLabel: string;
  /**FileTypes Allowed */
  fileTypes: any;
  isActiveUserSimulation: boolean;
  userData: any;
  assetData: any;
  json: any;
  isSubmitted = false;
  isDisabled: boolean;
  datePickerObjPtBr: any = {};
  timePickerObj: any = {};
  vehicleRegistrationDate: any;
  isBrowser = false;
  isAccidentWithOtherVehicle = false;
  isNextPoliceForm = false;
  isVehicle = false;
  isCyclistOrPedestrain = false;
  isThirdPartyDamaged = false;
  isSantander: string;
  licenseClass: string;
  land: string;
  isPoliceFormShow: false;
  isAnotherVehicleFormShow: false;
  allFormsAreValid = true;
  tabsState = {
    [this.translate.instant('RD_LABEL5')]: true,
    [this.translate.instant('RD_VEHICLE_LABEL')]: true,
    [this.translate.instant('RD_DRVIER_LABEL')]: true,
    [this.translate.instant('RD_LABEL7')]: true,
    [this.translate.instant('RD_LABEL9')]: true,
    [this.translate.instant('BICYCLE_OR_PEDESTRAIN')]: true,
    [this.translate.instant('OTHER_PROPERTY_DAMAGE')]: true,
    [this.translate.instant('RD_OTHER_LABEL')]: true,
    [this.translate.instant('RD_LABEL12')]: true,
    [this.translate.instant('RD_POLICE_LABEL')]: true,
    [this.translate.instant('RD_UP_LABEL')]: true,
  };

  // selectedDate;
  ngOnInit() {
    this.initializeFormAndConfig();
    this.setTimeValidation(); 
    window.addEventListener('resize', () => {
      this.setTimeValidation();
    });
  }

  private initializeFormAndConfig(): void {
    this.getPickerConf();
    // this.damageFormGroup = this.platform.is('cordova') ? this.createDamageForm() : this.createDamageFormWeb();
    this.damageFormGroup = this.createDamageForm();
    this.driverFormGroup = this.createDriverForm();
    this.vehicleFormGroup = this.createVehicleForm();
    this.getDamageType();
    this.translate.onDefaultLangChange.subscribe((event: DefaultLangChangeEvent) => {
      this.language = event.lang;
      this.translate.use(this.translate.getDefaultLang());

      this.customDatetimeOptions = {
        cssClass: 'datetime-bg-color'
      };
      this.getPickerConf();
    });

    this.isDisabled = false;
  }
  checking() {
    const dt = this.selTime;
  }
  private async showToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      color: 'danger',
      position: 'top',
    });
    await toast.present();
  }
  
  getPickerConf() {
    this.datePickerObjPtBr = {
      dateFormat: 'DD.MMM.YYYY',
      setLabel: this.translate.instant('FORGOT_LABEL9'),
      closeLabel: this.translate.instant('FUEL_LABEL8'),
      titleLabel: this.translate.instant('RD_LABEL29'),
      monthsList: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      todayLabel: this.translate.instant('TODAY_LABEL'),
    };
    this.timePickerObj = {
      timeFormat: 'HH:mm',
      inputTime: '',
      titleLabel: this.translate.instant('RD_LABEL30'),
      setLabel: this.translate.instant('FORGOT_LABEL9'),
      closeLabel: this.translate.instant('FUEL_LABEL8'),
    };
  }
  onChangeDate() {
    const dt = new Date();
    const regDt = new Date(this.damageModel.vehicle.firstRegistrationDate);
    const regDtWithTime = regDt.setHours(dt.getHours(), dt.getMinutes());
    this.damageModel.vehicle.firstRegistrationDate = new Date(new Date(regDtWithTime).toUTCString()).toISOString();

  }
  ngOnDestroy(): void {
    this.events.unsubscribe('assetData');
  }
  createDamageForm() {
    return this.formBuilder.group({
      date: ['', [Validators.required, noWhitespaceValidator()]],
      time: [''],
      tripType: [''],
      streetWithHouseNumber: ['', [Validators.required, Validators.maxLength(50), noWhitespaceValidator()]],
      postalCode: ['', [Validators.required, Validators.maxLength(10), noWhitespaceValidator()]],
      city: ['', [Validators.required,Validators.maxLength(50), noWhitespaceValidator()]],
      location: ['', [Validators.required, noWhitespaceValidator()]],
      course: ['', [Validators.required, noWhitespaceValidator()]],
      vehicleDamage: [''],
      recordedByPolice: [''],
      viewGuilty: [''],
      ddOwn: [''],
      ddOther: [''],
      ddPerson: [''],
      witness: [''],
      remarks: [''],
      culpabilityEm: [''],
      damageAreaVehicle: ['']
    });
  }
  createDriverForm() {
    return this.formBuilder.group({
      bankDetails: [''],
      bic: [''],
      company: ['', [Validators.required, noWhitespaceValidator()]],
      driverEmail: ['', [Validators.required, Validators.pattern(this.emailValidator), noWhitespaceValidator()]],
      driverMobile: ['', [Validators.required, Validators.pattern(this.phoneValidator), noWhitespaceValidator()]],
      driverFirstName: ['', [Validators.required, noWhitespaceValidator()]],
      driverLastName: ['', [Validators.required, noWhitespaceValidator()]],
      phone: ['', Validators.pattern(this.phoneValidator)],
      driverLp: [''],
      employment: [''],
      iban: [''],
      taxPermit: [''],
      vatId: [''],
      streetWithHouseNumber: [''],
      postalCode: [''],
      city: ['']
    });
  }
  createEuromasterForm() {
    return this.formBuilder.group({
      scn: ['', [Validators.required, noWhitespaceValidator()]],
      emLocation: ['', [Validators.required, noWhitespaceValidator()]],
      costCenter: [''],
      employeeLastName: ['', [Validators.required, noWhitespaceValidator()]],
      employeeFirstName: ['', [Validators.required, noWhitespaceValidator()]],
      employeeFunction: ['', [Validators.required, noWhitespaceValidator()]],
      employeeEmail: ['', [Validators.required, Validators.pattern(this.emailValidator), noWhitespaceValidator()]],
      employeePhone: ['', [Validators.required, Validators.pattern(this.phoneValidator), noWhitespaceValidator()]],
      salesArea: [''],
      salesManager: ['', [Validators.required, noWhitespaceValidator()]],
      mca: ['', [Validators.required, noWhitespaceValidator()]],
      majorCustomerId: ['', this.requiredIfValidator(() => this.euromasterFormGroup.get('mca').value)],
      majorCustomerName: ['', this.requiredIfValidator(() => this.euromasterFormGroup.get('mca').value)],
      otherInfo: [''],
      pc: ['', [Validators.required, noWhitespaceValidator()]],
      cc: ['', [Validators.required, noWhitespaceValidator()]],
    });
  }
  createKfzForm() {
    return this.formBuilder.group({
      lpNumber: ['', [Validators.required,Validators.maxLength(100), noWhitespaceValidator()]],
      vehicleMakeName: [''],
      damageType: [''],
      ownerCompanyName: ['', [Validators.required, noWhitespaceValidator()]],
      ownerName: ['', [Validators.required, noWhitespaceValidator()]],
      ownerStreetWithHouseNumber: [''],
      ownerPostalCode: [''],
      ownerCity: [''],
      ownerTelephone: ['', Validators.pattern(this.phoneValidator)],
      ownerEmail: ['', Validators.pattern(this.emailValidator)],
      driverFirstName: ['', [Validators.required, noWhitespaceValidator()]],
      driverLastName: ['', [Validators.required, noWhitespaceValidator()]],
      driverStreetWithHouseNumber: [''],
      driverPostalCode: [''],
      driverCity: [''],
      driverTelephone: ['', Validators.pattern(this.phoneValidator)],
      driverEmail: ['', Validators.pattern(this.emailValidator)],
      isAnotherVehicleInvolved: [false]
    })
  }

  createAnotherKfzForm() {
    return this.formBuilder.group({
      lpNumber: ['', [Validators.required, noWhitespaceValidator()]],
      vehicleMakeName: [''],
      damageType: [''],
      ownerCompanyName: ['', [Validators.required, noWhitespaceValidator()]],
      ownerName: ['', [Validators.required, noWhitespaceValidator()]],
      ownerStreetWithHouseNumber: [''],
      ownerPostalCode: [''],
      ownerCity: [''],
      ownerTelephone: ['', Validators.pattern(this.phoneValidator)],
      ownerEmail: ['', Validators.pattern(this.emailValidator)],
      driverFirstName: ['', [Validators.required, noWhitespaceValidator()]],
      driverLastName: ['', [Validators.required, noWhitespaceValidator()]],
      driverStreetWithHouseNumber: [''],
      driverPostalCode: [''],
      driverCity: [''],
      driverTelephone: ['', Validators.pattern(this.phoneValidator)],
      driverEmail: ['', Validators.pattern(this.emailValidator)],
    })
  }

  createBicyclePedestrainFormGroup() {
    return this.formBuilder.group({
      isPersonOrPedestrain: ['', [Validators.required, noWhitespaceValidator()]],
      firstName: ['', [Validators.required, noWhitespaceValidator()]],
      lastName: ['', [Validators.required, noWhitespaceValidator()]],
      streetWithHouseNumber: ['', [Validators.required, noWhitespaceValidator()]],
      postalCode: ['', [Validators.required, noWhitespaceValidator()]],
      city: ['', [Validators.required, noWhitespaceValidator()]],
      telephone: ['', Validators.pattern(this.phoneValidator)],
      email: ['', Validators.pattern(this.emailValidator)],
    })
  }

  createThirdPartyDamageForm() {
    return this.formBuilder.group({
      damagedItem: ['', [Validators.required, noWhitespaceValidator()]],
      firstName: ['', [Validators.required, noWhitespaceValidator()]],
      lastName: ['', [Validators.required, noWhitespaceValidator()]],
      streetWithHouseNumber: ['', [Validators.required, noWhitespaceValidator()]],
      postalCode: ['', [Validators.required, noWhitespaceValidator()]],
      city: ['', [Validators.required, noWhitespaceValidator()]],
      telephone: ['', Validators.pattern(this.phoneValidator)],
      email: ['', Validators.pattern(this.emailValidator)],
    })
  }

  createOtherPartyForm() {
    return this.formBuilder.group({
      companyAddress: [''],
      company: [''],
      otherEmail: ['', Validators.pattern(this.emailValidator)],
      otherMobile: ['', Validators.pattern(this.phoneValidator)],
      companyName: [''],
      otherphone: ['', Validators.pattern(this.phoneValidator)],
      driverLp: ['']
    });
  }
  createVehicleForm() {
    return this.formBuilder.group({
      cardOdometerReading: [''],
      firstRegistrationDate: [''],
      manufacturerKeyNumber: ['', Validators.maxLength(5)],
      odometerReading: [''],
      vin: ['', [Validators.pattern(this.vinValidator)]],
      lpNumber: ['', [Validators.required, noWhitespaceValidator()]],
      lpTrail: [''],
      storageADamage: [''],
      isChecked: [''],
      typeCodeNumber: ['', Validators.maxLength(5)],
      vehicleDrivable: [''],
      rent: ['']
    });
  }
  createOwnerForm() {
    return this.formBuilder.group({
      address: ['', [Validators.required, noWhitespaceValidator()]],
      bankDetails: [''],
      bic: [''],
      contactEmail: ['', Validators.pattern(this.emailValidator)],
      contactPhone: ['', Validators.pattern(this.phoneValidator)],
      employment: [''],
      iban: [''],
      name: ['', [Validators.required, noWhitespaceValidator()]],
      taxPermit: [''],
      vatId: ['']
    });
  }
  createPoliceForm() {
    return this.formBuilder.group({
      paidWarned: [''],
      department: ['', [Validators.required, noWhitespaceValidator()]],
      docket: [''],
      isDriverwarned: [''],
      isOpponentWarned: [''],
      isAccidentNotice: [''],
      officials: ['']
    });
  }
  requiredIfValidator(predicate) {
    return (formControl => {
      if (!formControl.parent) {
        return null;
      }
      if (predicate()) {
        return Validators.required(formControl);
      }
      return null;
    });
  }
  setTimeValidation() {
    const timeControl = this.damageFormGroup.get('time');
    if (this.platform.is('cordova')) {
      timeControl.setValidators([Validators.required, noWhitespaceValidator()]);

    } else if (this.platform.is('mobileweb') || this.isBrowser) {
      if (window.innerWidth < 768) {
        timeControl.setValidators([Validators.required, noWhitespaceValidator()]);
      } else {
        timeControl.clearValidators();
      }
    } else {
      timeControl.clearValidators();
    }
  
    timeControl.updateValueAndValidity();

    if (!this.isMaster) {
      const location = this.damageFormGroup.get('location');
      location.setValidators([Validators.required, noWhitespaceValidator()]);
      location.updateValueAndValidity();
    }
  }

  getDamageType() {
    this.coreService.showLoader();
    fetch('assets/data/report-damage.json').then(res => res.json())
      .then(async json => {
        this.reportObjectDamage = json.reportObjectDamage;
        if (this.router.url === '/damage-survey-external/euromaster') {
          this.updateValidation();
          this.setFieldsForEuroMaster(json);
          this.countryNames = json.countries;
        } else {
          // this.damageFormGroup = this.createDamageForm();
          this.isMaster = false;
          this.reportTypeDamage = json.damage;
          this.categories = json.categories;
          this.policeFormGroup = this.createPoliceForm();
          this.damageModel = json.damageObj;
          this.countryNames = json.countries;
          this.drivingLicenseClass = json.drivingLicenseClass;

          this.kfzModel = Object.assign({}, json.otherParties);
          this.kfzModel.person = Object.assign({}, json.otherParties.person);
          this.kfzModel.person.address = Object.assign({}, json.otherParties.person.address);
          this.kfzModel.person.contact = Object.assign({}, json.otherParties.person.contact);
          this.kfzModel.vehicleOwner = Object.assign({}, json.otherParties.vehicleOwner);
          this.kfzModel.vehicleOwner.address = Object.assign({}, json.otherParties.vehicleOwner.address);
          this.kfzModel.vehicleOwner.contact = Object.assign({}, json.otherParties.vehicleOwner.contact);

          this.anotherKfzModel = Object.assign({}, json.otherParties);
          this.anotherKfzModel.person = Object.assign({}, json.otherParties.person);
          this.anotherKfzModel.person.address = Object.assign({}, json.otherParties.person.address);
          this.anotherKfzModel.vehicleOwner = Object.assign({}, json.otherParties.vehicleOwner);
          this.anotherKfzModel.vehicleOwner.address = Object.assign({}, json.otherParties.vehicleOwner.address);
          this.anotherKfzModel.vehicleOwner.address = Object.assign({}, json.otherParties.vehicleOwner.address);
          this.anotherKfzModel.vehicleOwner.contact = Object.assign({}, json.otherParties.vehicleOwner.contact);

          this.bicyclePedestrainModel = Object.assign({}, json.otherParties);
          this.bicyclePedestrainModel.person = Object.assign({}, json.otherParties.person);
          this.bicyclePedestrainModel.person.address = Object.assign({}, json.otherParties.person.address);
          this.bicyclePedestrainModel.person.contact = Object.assign({}, json.otherParties.person.contact);

          this.thirdPartyModel = Object.assign({}, json.otherParties);
          this.thirdPartyModel.person = Object.assign({}, json.otherParties.person);
          this.thirdPartyModel.person.address = Object.assign({}, json.otherParties.person.address);
          this.thirdPartyModel.person.contact = Object.assign({}, json.otherParties.person.contact);

          this.selectedLabel = 'RD_LABEL5';
          this.drsegment = this.translate.instant('RD_LABEL5');
          this.selectedTab = this.translate.instant('RD_LABEL5');
          this.fileTypes = json.allowedFileType;

          this.land = this.damageModel.damage.country;
          this.damageFormGroup.get('location').setValue(this.land);
        }
        if (this.router.url === '/report-damage') {
          // this.damageFormGroup = this.createDamageForm();
          this.policeFormGroup = this.createPoliceForm();
          this.isActiveUserSimulation = localStorage.getItem('isActiveUserSimulation') ? true : false;
          if (this.userData) {
            this.damageModel.driver.driverFirstName = this.userData.firstName;
            if (this.userData.lastName) {
              this.damageModel.driver.driverLastName = this.userData.lastName;
            }
            this.damageModel.driver.driverPhone = this.userData.phone;
            this.damageModel.driver.driverMobile = this.userData.mobile;
            this.damageModel.driver.driverEmail = this.userData.email;
          }
          if (this.assetData) {
            this.damageModel.vehicle.vehicleIdentificationNumber = this.assetData.asset.vin;
            this.damageModel.vehicle.vehicleLicensePlateNumber = this.assetData.asset.licensePlateNumber;
          }
        }
        this.setTimeValidation();
        this.selectedTab = this.translate.instant(this.selectedLabel);
        this.drsegment = this.translate.instant(this.selectedLabel);
        await this.clickedTab(this.selectedLabel);
        this.coreService.hideLoader();
      });
  }

  async getDriverLicenseClass(ev: any) {
    const popover = await this.popoverController.create({
      component: QuestionsPopoverPage,
      componentProps: {
        data: this.drivingLicenseClass,
        type: "License-Class"
      },
      event: ev,
      translucent: true,
      showBackdrop: false,
    });
    this.events.subscribe("fromLicenseClassEvent", (data) => {
      if (data) {
        this.licenseClass = data.data;
        this.damageModel.driver.driversLicenseClass = data.data;
        this.events.unsubscribe("fromLicenseClassEvent");
      }
    });
    return await popover.present();
  }
  async getLand(ev: any) {
    const popover = await this.popoverController.create({
      component: QuestionsPopoverPage,
      componentProps: {
        data: this.countryNames,
        type: "Land"
      },
      event: ev,
      translucent: true,
      showBackdrop: false,
    });
    this.events.subscribe("fromLand", (data) => {
      if (data) {
        this.land = data.data;
        this.isMaster
          ? (this.damageModel.damage.eventlocation = data.data)
          : (this.damageModel.damage.country = data.data);
        this.damageFormGroup.get('location').setValue(this.isMaster ? this.damageModel.damage.eventlocation : this.damageModel.damage.country);
        this.events.unsubscribe("fromLand");
      }
    });
    return await popover.present();
  }

  async onSubmitErrorScroll(nextTabName, isGoToNextTab: boolean, elem?: string, formGroup?: FormGroup) {
    if (formGroup.valid) {
      if (isGoToNextTab) {
        await this.goToNextTab(elem);
      } else {
        await this.selectTab(nextTabName, elem);
      }
    } else {
      this.errorScroll(formGroup);
    }
  }

  updateValidation() {
    this.damageFormGroup.get('location').clearValidators();
    this.damageFormGroup.get('location').updateValueAndValidity();
  }

  async checkValidity(isSubmit = false) {
  try {
    if (!Array.isArray(this.categories) || this.categories.length === 0) {
      // console.warn('Categories are not initialized or empty.'); //Kept for error logging
      await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
      this.reloadPageData();
      return;
    }

    let validStatusOfForms = [];
    for (const obj of this.categories) {
      if (!obj || !obj.name) continue;

      try {
        if (obj.name === 'RD_LABEL7') {
          obj.isValid = this.damageModel && Array.isArray(this.damageModel.targets) && this.damageModel.targets.length > 0;
        } else if (obj.name === 'RD_LABEL5') {
          obj.isValid = this.damageModel && this.damageModel.kind != null;
        } else if (obj.form) {
          const form = this[obj.form];
          if (form && typeof form.valid !== 'undefined') {
            obj.isValid = form.valid;
          } else {
            console.warn(`Form "${obj.form}" not found or invalid.`);
            obj.isValid = false;
          }

          if (!obj.isDisable && isSubmit) {
            try {
              if (this.makeFormControlsDirty) {
                this.makeFormControlsDirty(obj.form);
              }
            } catch (e) {
              // console.error(`Error marking form "${obj.form}" dirty:`, e); //Kept for error logging
              await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
              this.reloadPageData();
            }
            validStatusOfForms.push(obj.isValid);
            this.allFormsAreValid = !validStatusOfForms.includes(false);
          }
        }
      } catch (innerErr) {
        // console.error(`Error processing category "${obj.name}":`, innerErr); //Kept for error logging
        obj.isValid = false;
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
      }
    }
  } catch (err) {
      // console.error('Error in checkValidity():', err);  //Kept for error logging
      await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
      this.reloadPageData();
  }}

  async clickedTab(name) {
    await this.checkValidity();
    const currentTabValue = (this.isBrowser || this.isApp) ? this.selectedTab : this.drsegment;
    const index = this.categories.map((obj) => this.translate.instant(obj.name)).indexOf(currentTabValue);
    const i = index - 1;
    if (i >= 0) {
      this.previousTabName = this.categories[i].name;
    }
    if (name === 'Back') {
      const label = this.isMaster ? 'RD_MASTER_LABEL1' : this.previousTabName;
      const nextIndex = this.categories.map((obj) => this.translate.instant(obj.name)).indexOf(this.translate.instant('RD_LABEL7'));
      this.drsegment = this.translate.instant(this.previousTabName);
      this.selectedTab = this.translate.instant(this.previousTabName);
      this.selectedLabel = this.previousTabName;
    } else if (name === 'Other') {
      const label = this.isMaster ? 'RD_MASTER_LABEL1' : 'RD_DRVIER_LABEL';
      this.drsegment = this.translate.instant(label);
      this.selectedTab = this.translate.instant(label);
      this.selectedLabel = label;
    }
    else if (name === 'DamagedObject') {
      this.drsegment = this.translate.instant(this.previousTabName);
      this.selectedTab = this.translate.instant(this.previousTabName);
      this.selectedLabel = this.previousTabName;
    }
    else {
      if (currentTabValue === this.translate.instant('RD_UP_LABEL') || currentTabValue === this.translate.instant('RD_UP_LABEL3'))
        name = this.isMaster ? this.previousTabName : (this.isPoliceFormShow ? name : 'RD_LABEL12');
      this.drsegment = this.translate.instant(name);
      this.selectedTab = this.translate.instant(name);
      this.selectedLabel = name;
    }
  }
  async setVehicleFormData() {
    const tabName = this.drsegment;
    this.damageModel.vehicle.vehicleIdentificationNumber = this.assetData.asset.vin;
    this.damageModel.vehicle.vehicleLicensePlateNumber = this.assetData.asset.licensePlateNumber;
    await this.clickedTab('RD_LABEL5');
    await new Promise(resolve => setTimeout(resolve, 20));
    this.cdRef.detectChanges();
    await this.clickedTab(tabName);
    this.makeFormControlsDirty('vehicleFormGroup');
  }
 async clickedItemtype(event: any, selected: any) {
    try {
      if (!selected || typeof selected.value === 'undefined') {
        // console.warn('Invalid selected item:', selected);    //Kept for error logging
         await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
        return;
      }
      this.selectedItem = selected;
      if (!this.damageModel) this.damageModel = {};
      this.damageModel.kind = selected.value;
      this.isType = true;
      const translatedNames = (this.categories || []).map((obj) =>
      (this.translate && this.translate.instant(obj && obj.name || '')) || ''
      );
      const index = translatedNames.indexOf(this.translate ? this.translate.instant('RD_LABEL7') : '');
      if (selected.value === 'AccidentWithOtherVehicle') {
        this.isAccidentWithOtherVehicle = true;
        this.isNextPoliceForm = false;
        try {
          this.otherPartyFormGroup = this.createOtherPartyForm && this.createOtherPartyForm();
        } catch (e) {
          // console.error('Error creating Other Party form:', e);   //Kept for error logging
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
        }
        if (index < 0) {
          if (this.isMaster) {
            this.categories.splice(6, 0, { name: 'RD_OTHER_LABEL', width: '6', form: 'otherPartyFormGroup', isValid: false });
          } else {
            this.categories.splice(3, 0, { name: 'RD_LABEL7', width: '6', form: 'null', isValid: false, 'isDisable': true });
          }
        }
      }
      else if (selected.value === 'GlassBreakage' || selected.value === 'EnvironmentalDamage') {
        this.isNextPoliceForm = true;
      }
      else {
        this.isAccidentWithOtherVehicle = false;
        if (index >= 0 && Array.isArray(this.categories)) {
          try {
            this.categories.splice(index, 1);
          } catch (e) {
            // console.error('Error removing RD_LABEL7 from categories:', e);   //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
          }
          this.isVehicle = false;
          this.isNextPoliceForm = false;
          this.isCyclistOrPedestrain = false;
          this.isThirdPartyDamaged = false;
          this.isAnotherVehicleFormShow = false;
          try {
            if (this.removeTab) {
              this.removeTab('RD_LABEL9');
              this.removeTab('BICYCLE_OR_PEDESTRAIN');
              this.removeTab('OTHER_PROPERTY_DAMAGE');
              this.removeTab('ANOTHER_KFZ');
            }

          } catch (e) {
            // console.error('Error removing related tabs:', e);  //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
          }
          this.selectedItemType = [];
        }
      }
      try {
       if (this.checkValidity) {
        await this.checkValidity();
      }
      } catch (err) {
        // console.error('Error checking validity:', err);   //Kept for error logging
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
      }
    } catch (err) {
      // console.error('Error in clickedItemtype():', err);   //Kept for error logging
      await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
      this.reloadPageData();
    }
  }

  async goToNextTab(elem?: string) {
    try {
      if (!this.categories || this.categories.length === 0) {
        // console.warn('Categories are not initialized.');    //Kept for error logging
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
        return;
      }

      const currentTabValue = (this.isBrowser || this.isApp) ? this.selectedTab : this.drsegment;
      const index = this.categories
      .map(obj => this.translate.instant(obj && obj.name ? obj.name : ''))
      .indexOf(currentTabValue);


      if (index < 0 || index >= this.categories.length) {
        // console.warn('Invalid tab index:', index);      //Kept for error logging
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
        return;
      }

      const form = this.categories[index] ? this.categories[index].form : undefined;
      const i = index + 1;
      const nextTabObj = this.categories[i];
      var nextTabName = nextTabObj ? nextTabObj.name : null;

      if (this.isMaster) {
        if ((form && this[form] ? this[form].valid : false) || (index === 1)) {
          this.categories[index].isValid = true;
          if (nextTabName) {
            if (form === 'ownerFormGroup') {
              const nextIndex = this.categories
                .map(obj => this.translate.instant(obj && obj.name ? obj.name : ''))
                .indexOf(this.translate.instant('RD_OTHER_LABEL'));
              nextIndex < 0
                ? await this.selectTab(this.translate.instant('RD_VEHICLE_LABEL'))
                : await this.selectTab(this.translate.instant('RD_OTHER_LABEL'));
            } else {
              await this.selectTab(nextTabName, elem);
            }
          } else {
            if (this.isApp || this.isBrowser) {
              await this.selectTab(nextTabName, elem);
            }
            this.setSegment(index);
          }
        } else {
          if (form && this[form]) {
            this.makeFormControlsDirty(form);
          } else {
            // console.warn('Form not found:', form);      //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
            return;
          }
        }
      } else {
      if (
        (currentTabValue === this.translate.instant('RD_LABEL7')) ||
        (form && this[form] ? this[form].valid : false) ||
        (index === 0)
      ){
          this.categories[index].isValid = true;
          if (index < this.categories.length - 1 && this.categories[index + 1]) {
            this.categories[index + 1].isDisable = false;
          }
          if (nextTabName) {
            if (form === 'driverFormGroup') {
              const nextIndex = this.categories
              .map(obj => this.translate.instant(obj && obj.name ? obj.name : ''))
              .indexOf(this.translate.instant('RD_LABEL7'));
              nextIndex < 0 ? await this.selectTab(this.translate.instant('RD_LABEL12')) : this.selectTab(this.translate.instant('RD_LABEL7'));
            } else if (currentTabValue === this.translate.instant('RD_LABEL12')) {
              this.isPoliceFormShow = 
              this.damageFormGroup && this.damageFormGroup.get('recordedByPolice')
                ? this.damageFormGroup.get('recordedByPolice').value
                : undefined;
              if (this.isPoliceFormShow) {
                nextTabName = this.translate.instant('RD_POLICE_LABEL');
                this.resetValidation('policeFormGroup', 'department', true);
              } else {
                nextTabName = this.translate.instant('RD_UP_LABEL');
                if (this.categories[index + 1]) {
                  this.categories[index + 1].isDisable = true;
                }
                if (this.tabsState) {
                  this.tabsState[this.translate.instant('RD_POLICE_LABEL')] = true;
                }
                this.resetValidation('policeFormGroup', 'department', false);
              }
              await this.selectTab(nextTabName, elem);
            }
            else if (currentTabValue === this.translate.instant('RD_LABEL9')) {
              this.isAnotherVehicleFormShow =
              this.kfzFormGroup && this.kfzFormGroup.get('isAnotherVehicleInvolved')
                ? this.kfzFormGroup.get('isAnotherVehicleInvolved').value
                : undefined;
              if (this.isAnotherVehicleFormShow) {
                nextTabName = this.translate.instant('ANOTHER_KFZ');
                if (this.createAnotherKfzForm) {
                  this.anotherKfzFormGroup = this.createAnotherKfzForm();
                }
                if (!this.categories.some(category => category && category.name === 'ANOTHER_KFZ')) {
                  this.categories.splice(5, 0, {
                    name: 'ANOTHER_KFZ',
                    width: '6',
                    form: 'anotherKfzFormGroup',
                    isvalid: false,
                    isDisable: false
                  });
                }
              } else {
                if (this.removeTab) {
                  this.removeTab('ANOTHER_KFZ');
                }
                nextTabName = this.categories[index + 1] ? this.categories[index + 1].name : undefined;
              }
              await this.selectTab(nextTabName, elem);
            } else {
              await this.selectTab(nextTabName, elem);
            }
          } else {
            if (this.isApp || this.isBrowser) {
              await this.selectTab(nextTabName, elem);
            }
            this.setSegment(index);
          }
        } else {
          if (form && this[form]) {
            this.makeFormControlsDirty(form);
          } else {
            // console.warn('Form not found:', form);   //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
            return;
          }
        }
      }
    } catch (error) {
      // console.error('Error in goToNextTab:', error);   //Kept for error logging
      await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
      this.reloadPageData();
    }
  }

  async setSegment(index) {
    try {
      if (!Array.isArray(this.categories) || this.categories.length === 0) {
        // console.warn('Categories list is empty or not initialized.');   //Kept for error logging
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
        return;
      }
      const i = index + 1;
      if (i < 0 || i >= this.categories.length) {
        // console.warn(`Invalid category index: ${i}`);   //Kept for error logging
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
        return;
      }
      const categoryName = this.categories[i] ? this.categories[i].name : undefined;
      if (!categoryName) {
        // console.warn(`Category name not found at index ${i}`);     //Kept for error logging
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
        return;
      }
      const translatedName = this.translate ? this.translate.instant(categoryName) : categoryName;
      this.selectedLabel = categoryName;
      this.drsegment = translatedName;
      this.selectedTab = translatedName;
    } catch (err) {
      // console.error('Error in setSegment():', err);   //Kept for error logging
      await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
      this.reloadPageData();
    }
  }

  makeFormControlsDirty(form) {
    const controls = this[form].controls;
    Object.keys(this[form].controls).forEach(key => {
      this[form].get(key).markAsDirty();
    });
  }
  
  removeTab(name) {
    const tabIndex = this.categories.findIndex(tab => tab.name === name);
    if (tabIndex !== -1) {
      this.categories.splice(tabIndex, 1);
    }
  };

  async clickedItemObject(event, selected: any) {
    const flag = selected.isSelected;
    selected.isSelected = !flag;
    if (!this.selectedItemType || !this.selectedItemType.length) {
      this.selectedItemType = [];
      if (selected.isSelected) {
        this.selectedItemType.push(selected.value);
      }
    } else {
      if (selected.isSelected) {
        this.selectedItemType.push(selected.value);
      } else {
        const index = this.selectedItemType.indexOf(selected.value);
        this.selectedItemType.splice(index, 1);
      }
    }
    this.damageModel.targets = this.selectedItemType;
    this.isThing = this.selectedItemType.indexOf('Thing') > -1 ? true : false;
    this.isPerson = this.selectedItemType.indexOf('Person') > -1 ? true : false;
    await this.conditionalTabs(selected);
    await this.checkValidity()
  }

  async conditionalTabs(selected: any) {
    try {
      if (!selected || typeof selected.value === 'undefined') {
        //console.warn('Invalid selected value:', selected); //Kept for error logging
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
        return;
      }

      if (!Array.isArray(this.categories)) {
        console.warn('Categories list is not initialized.');
        this.categories = [];
      }

      let insertIndex = 4;
      if (selected.value === 'Vehicle' && this.isAccidentWithOtherVehicle) {
        if (selected.isSelected) {
          this.isVehicle = true;
          try {
           if (this.createKfzForm) {
              this.kfzFormGroup = this.createKfzForm();
            }
          } catch (e) {
            // console.error('Error creating KFZ form:', e);  //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
          }
          this.categories.splice(insertIndex, 0, { name: 'RD_LABEL9', width: '6', form: 'kfzFormGroup', isvalid: false, isDisable: true })
        }
        else {
          this.isAnotherVehicleFormShow = false;
          this.isVehicle = false;
          try {
          if (this.removeTab) {
            this.removeTab('RD_LABEL9');
            this.removeTab('ANOTHER_KFZ');
          }
          } catch (e) {
            // console.error('Error removing vehicle tabs:', e);  //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
          }
        }
      }
      else if (selected.value === 'Person' && this.isAccidentWithOtherVehicle) {
        if (selected.isSelected) {
          this.isCyclistOrPedestrain = true;
          try {
          if (this.createBicyclePedestrainFormGroup) {
            this.bicyclePedestrainFormGroup = this.createBicyclePedestrainFormGroup();
          }
          } catch (e) {
            // console.error('Error creating Bicycle/Pedestrian form:', e);    //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
          }
          if (this.isVehicle && this.isAnotherVehicleFormShow)
            insertIndex += 2;
          else if (this.isVehicle)
            insertIndex += 1;
          this.categories.splice(insertIndex, 0, { name: 'BICYCLE_OR_PEDESTRAIN', width: '6', form: 'bicyclePedestrainFormGroup', isvalid: false, isDisable: true })
        }
        else {
          this.isCyclistOrPedestrain = false;
          try {
          if (this.removeTab) {
            this.removeTab('BICYCLE_OR_PEDESTRAIN');
          }

          } catch (e) {
            // console.error('Error removing Bicycle/Pedestrian tab:', e);   //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
          }
        }
      }
      else if (selected.value === 'Thing' && this.isAccidentWithOtherVehicle) {
        if (selected.isSelected) {
          this.isThirdPartyDamaged = true;
          try {
          if (this.createThirdPartyDamageForm) {
            this.thirdPartyDamage = this.createThirdPartyDamageForm();
          }
          } catch (e) {
            // console.error('Error creating Third Party Damage form:', e);  //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
          }
          if (this.isVehicle && this.isAnotherVehicleFormShow && this.isCyclistOrPedestrain)
            insertIndex += 3;
          else if (this.isVehicle && this.isCyclistOrPedestrain)
            insertIndex += 2;
          else if (this.isVehicle)
            insertIndex += 1;
          this.categories.splice(insertIndex++, 0, { name: 'OTHER_PROPERTY_DAMAGE', width: '6', form: 'thirdPartyDamage', isvalid: false, isDisable: true })
        }
        else {
          this.isThirdPartyDamaged = false;
          try {
          if (this.removeTab) {
            this.removeTab('OTHER_PROPERTY_DAMAGE');
          }
          } catch (e) {
            // console.error('Error removing Third Party Damage tab:', e);  //Kept for error logging
            await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
            this.reloadPageData();
          }
        }
      }
      else if ((selected.value === 'Vehicle' || selected.value === 'Person' || selected.value === 'Thing') && !this.isAccidentWithOtherVehicle) {
        try {
          if (this.removeTab) {
            this.removeTab('RD_LABEL9');
            this.removeTab('BICYCLE_OR_PEDESTRAIN');
            this.removeTab('OTHER_PROPERTY_DAMAGE');
            this.removeTab('ANOTHER_KFZ');
          }
        } catch (e) {
          // console.error('Error removing tabs for no-vehicle case:', e);  //Kept for error logging
          await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
          this.reloadPageData();
        }
      }
    } catch (err) {
      // console.error('Error in conditionalTabs():', err);   //Kept for error logging
      await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
      this.reloadPageData();
    }
  }

  errorScroll(formGroup: FormGroup) {
    for (let field in formGroup.controls) {
      const control = formGroup.get(field);
      if (control.invalid) {
        const invalidField = document.getElementById(field);
        const validators = control.validator({} as AbstractControl); // Calling the validator function
        const isRequired = validators && validators.required;
        if (isRequired && control.value === null) {
          control.markAsDirty();
        }
        if (invalidField) {
          invalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          break;
        }
      }
    }
  }
  scroll(elem: string) {
    document.querySelector(`#${elem}`).scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  async selectTab(tabValue, elem?: string) {
    try {
      if (this.checkValidity) {
        this.checkValidity();
      }
      const currentTabValue = (this.isBrowser || this.isApp) ? this.selectedTab : this.drsegment || '';
      if (!Array.isArray(this.categories) || this.categories.length === 0) {
        // console.warn('Categories not found or empty.');  //Kept for error logging
        await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
        this.reloadPageData();
        return;
      }
      const translatedNames = this.categories.map(obj =>
        this.translate && obj && obj.name ? this.translate.instant(obj.name) : ''
      );
      const index = translatedNames.indexOf(currentTabValue);
      const i = index - 1;
      if (i >= 0 && this.categories[i] && this.categories[i].name) {
        this.previousTabName = this.categories[i].name;
      }

      if (tabValue === 'Back') {
        const nextIndex = translatedNames.indexOf(
        this.translate ? this.translate.instant('RD_LABEL7') : ''
        );
        const prevName = this.translate ? this.translate.instant(this.previousTabName) : '';
        if (prevName) {
          this.selectedTab = prevName;
          this.drsegment = prevName;
          if (this.tabsState) this.tabsState[prevName] = false;
        }
      } else if (tabValue === 'Next') {
        const nextIndex = translatedNames.indexOf(
          this.translate ? this.translate.instant('RD_LABEL7') : ''
        );
        const nextTab = nextIndex < 0
        ? (this.translate ? this.translate.instant('RD_LABEL12') : 'RD_LABEL12')
        : (this.translate ? this.translate.instant('RD_LABEL7') : 'RD_LABEL7');
        this.selectedTab = nextTab;
        this.drsegment = nextTab;
        if (this.tabsState) this.tabsState[nextTab] = false;
      }
      else if (tabValue === 'DamagedObject') {
        const prevName = this.translate ? this.translate.instant(this.previousTabName) : '';
        if (prevName) {
          this.drsegment = prevName;
          this.selectedTab = prevName;
          if (this.tabsState) this.tabsState[prevName] = false;
        }
      } else {
        if (currentTabValue === (this.translate ? this.translate.instant('RD_UP_LABEL') : 'RD_UP_LABEL'))
          tabValue = this.isPoliceFormShow ? tabValue : 'RD_LABEL12';
        const nextTab = this.translate ? this.translate.instant(tabValue) : tabValue;
        this.selectedTab = nextTab;
        this.drsegment = nextTab;
        if (this.tabsState) this.tabsState[nextTab] = false;
      }

      if (elem && typeof this.scroll === 'function') {
        setTimeout(async () => {
          try {
            this.scroll(elem);
          } catch (scrollErr) {
            console.error('Scroll failed:', scrollErr); //Kept for error logging
          }
        }, 0);
      }
    } catch (err) {
      // console.error('Error in selectTab():', err);  //Kept for error logging
      await this.coreService.presentAlert(this.translate.instant('SOMETHING_WENT_WRONG'));
      this.reloadPageData();
    }
  }
  selectDate() {
    this.updateDate();
  }
  selectTime() {
    this.updateDate();
  }
  updateDate() {
    if (this.selDate && this.selTime) {
      const index = this.selDate.indexOf('T');
      const date = this.selDate.substr(0, index);
      const time = this.selTime.substr(index);
      const properDate = date.concat(time);
      this.damageModel.damage.damageDateTime = new Date(new Date(properDate).toUTCString()).toISOString();
    } else {
      return;
    }
  }
  setFieldsForEuroMaster(json) {
    this.reportTypeDamage = json.euroMasterDamage;
    this.categories = json.euroMasterCategories;
    this.euromasterFormGroup = this.createEuromasterForm();
    this.ownerFormGroup = this.createOwnerForm();
    this.isMaster = true;
    this.damageModel = json.euroMasterObj;
    this.fileTypes = json.allowedFileTypeForEuroMaster;
    this.selectedLabel = 'RD_MASTER_LABEL';
    this.drsegment = this.translate.instant('RD_MASTER_LABEL');
    this.selectedTab = this.translate.instant('RD_MASTER_LABEL');
    this.land = this.damageModel.damage.eventLocation;
  }
  getEuromasterFunction() {
    const phone = ',' + this.employeePhone;
    const email = ',' + this.employeeEmail;
    const concatedStr = phone.concat(email);
    const finalStr = this.damageModel.euromaster.employeeFunction.concat(concatedStr);
    return finalStr;
  }
  async reportDamageForm() {
    this.isSubmitted = true;
    this.checkValidity(true);    
    // tslint:disable-next-line: max-line-length
    if (!this.allFormsAreValid || (this.damageModel.kind === null || !this.damageFormGroup.valid
      || !this.vehicleFormGroup.valid || (this.otherPartyFormGroup && !this.otherPartyFormGroup.valid))) {
      this.coreService.presentToastWithOptions(this.translate.instant('RD_OTHER_LABEL2'), 'warning');
      return;
    }
    if (this.router.url === '/damage-survey-external' ||this.router.url === '/damage-survey-external/euromaster') {
      if (!this.captchaResolved) {
        const modal = await this.modalCtrl.create({
          component: CaptchaModalComponent,
          componentProps: {
            siteKey: this.recaptchaKey,
          },
        });

        await modal.present();

        const { data } = await modal.onWillDismiss();
        if (data) {
          this.captchaResolved = true;
          this.submitDamageForm(); 
        }

        return;
      }
    }
    this.submitDamageForm();
  }

  cleanPhoneFields() {
    if (this.damageModel.driver) {
      if (!this.damageModel.driver.driverPhone || this.damageModel.driver.driverPhone.trim() === '') {
        this.damageModel.driver.driverPhone = null;
      }
    }

    if (this.damageModel.otherParties && this.damageModel.otherParties.length) {
      this.damageModel.otherParties.forEach(party => {

        if (party.person && party.person.contact) {
          if (!party.person.contact.phone || party.person.contact.phone.trim() === '') {
            party.person.contact.phone = null;
          }
        }

        if (party.vehicleOwner && party.vehicleOwner.contact) {
          if (!party.vehicleOwner.contact.phone || party.vehicleOwner.contact.phone.trim() === '') {
            party.vehicleOwner.contact.phone = null;
          }
        }

      });
    }
  }

  submitDamageForm() {
      this.coreService.showLoader();
      if (this.isLoggedInUser) {
        this.damageModel.otherParties = [];
        if (this.damageModel.targets.includes('Vehicle')) {
          this.kfzModel.type = 'Vehicle';
          this.damageModel.otherParties.push(this.kfzModel);
          if (this.isAnotherVehicleFormShow) {
            this.anotherKfzModel.type = 'Vehicle';
            this.damageModel.otherParties.push(this.anotherKfzModel);
          }
        }
        if (this.damageModel.targets.includes('Person')) {
          this.bicyclePedestrainModel.vehicleOwner = null;
          this.damageModel.otherParties.push(this.bicyclePedestrainModel);
        }
        if (this.damageModel.targets.includes('Thing')) {
          this.thirdPartyModel.type = 'Thing';
          this.thirdPartyModel.vehicleOwner = null;
          this.damageModel.otherParties.push(this.thirdPartyModel);
        }
        if ((this.isAccidentWithOtherVehicle && this.damageModel.targets.length === 0) || !this.driverFormGroup.valid) {
          this.coreService.hideLoader();
          this.coreService.presentToastWithOptions(this.translate.instant('RD_OTHER_LABEL2'), 'warning');
          return;
        }
        this.isDisabled = true;
        if (this.isDisabled) {
          this.cleanPhoneFields();
          this.damageService.reportNewDamage(this.damageModel).subscribe(
            async (resp: any) => {
            this.isDisabled = false;
            Object.keys(this.tabsState).forEach(key => {
              this.tabsState[key] = true;
            });
            await this.coreService.hideLoader();
            await this.coreService.presentToastWithOptions(this.translate.instant('MSG11'), 'success');
            this.reloadPageData();
          },  
            async (error) => {
            await this.coreService.hideLoader();
            this.handleError(error);
            this.isDisabled = false;
            this.cdRef.detectChanges();
          });
        }
      } else {
        if (this.isMaster) {
          this.damageModel.targets = [];
          this.damageModel.targets.push('Vehicle');
          this.damageModel.euromaster.employeeFunction = this.getEuromasterFunction();
          this.damageModel.damage.eventLocation = `${this.damageModel.damage.streetWithHouseNumber} ${this.damageModel.damage.postalCode} ${this.damageModel.damage.city} ${this.damageModel.damage.eventLocation}`.trim();
         if (!this.imageBase64 || this.imageBase64.length === 0) {
           this.damageModel.attachments = null;
          } else {
           this.damageModel.attachments = this.imageBase64;
          }       
          if (this.euromasterFormGroup.valid && this.ownerFormGroup.valid) {
            this.damageService.euromasterReportNewDamage(this.damageModel).subscribe( 
              async (resp: any) => {
              await this.coreService.hideLoader();
              await this.coreService.presentToastWithOptions(this.translate.instant('MSG31'), 'success');
              this.reloadPageData();
            },async (error) => {
              await this.coreService.hideLoader();
              this.handleError(error);
            });
          } else {
            this.coreService.presentToastWithOptions(this.translate.instant('RD_OTHER_LABEL2'), 'warning');
            return;
          }
        } else {
          this.damageModel.otherParties = [];
          if (this.damageModel.targets.includes('Vehicle')) {
            this.kfzModel.type = 'Vehicle';
            this.damageModel.otherParties.push(this.kfzModel);
            if (this.isAnotherVehicleFormShow) {
              this.anotherKfzModel.type = 'Vehicle';
              this.damageModel.otherParties.push(this.anotherKfzModel);
            }
          }

          if (this.damageModel.targets.includes('Person')) {
            this.bicyclePedestrainModel.vehicleOwner = null;
            this.damageModel.otherParties.push(this.bicyclePedestrainModel);
          }
          if (this.damageModel.targets.includes('Thing')) {
            this.thirdPartyModel.type = 'Thing';
            this.thirdPartyModel.vehicleOwner = null;
            this.damageModel.otherParties.push(this.thirdPartyModel);
          }
          if (this.isAccidentWithOtherVehicle && this.damageModel.targets.length === 0 || !this.driverFormGroup.valid) {
            this.coreService.hideLoader();
            this.coreService.presentToastWithOptions(this.translate.instant('RD_OTHER_LABEL2'), 'warning');
            return;
          }
          this.cleanPhoneFields();
          this.damageService.reportNewDamageForUnauth(this.damageModel).subscribe(
            async (resp: any) => {
            await this.coreService.hideLoader();
            await this.coreService.presentToastWithOptions(this.translate.instant('MSG11'), 'success');
          this.reloadPageData();
        },async (error) => {
          await this.coreService.hideLoader();
          this.handleError(error);
          });
        }
      }
  }

  handleError(error: any) {
    if (!error || error.status !== 400) {
      this.coreService.presentAlert(
        this.translate.instant('RD_OTHER_LABEL2')
      );
      return;
    }

    if (
      error.error &&
      error.error.type === 'business' &&
      error.error.errors &&
      typeof error.error.errors === 'object'
    ) {
      var messages: string[] = [];

      Object.keys(error.error.errors).forEach(function (key) {
        var value = error.error.errors[key];
        if (Array.isArray(value)) {
          messages = messages.concat(value);
        }
      });

      if (messages.length > 0) {
        var uniqueMessages = messages.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });

        this.coreService.presentAlert(uniqueMessages.join('\n'));
        return;
      }
    }

    this.coreService.presentAlert(
      this.translate.instant('RD_OTHER_LABEL2')
    );
  }

  reloadPageData() {
    var url = this.router.url;
    this.isMobileApp = this.platform.is('cordova');
    this.coreService.showLoader();
    window.location.reload();
  }
  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const testStr = reader.result.toString();
      const returnStr = testStr.substr(testStr.indexOf(',') + 1);
      resolve(returnStr);
    };
    reader.onloadend = () => {
      const testStr = reader.result.toString();
      const returnStr = testStr.substr(testStr.indexOf(',') + 1);
      resolve(returnStr);
    };
    reader.onerror = error => {
      reject(error);
    };
  })
  async presentActionSheet(ev) {
    const isApp = this.platform.is('pwa');
    if (this.isApp && !this.isBrowser) {
      const actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant('SELECT_LABEL'),
        buttons: [
          {
            text: this.translate.instant('CAM_LABEL'),
            cssClass: 'camera_button',
            icon: 'camera',
            handler: () => {
              this.showCamera(this.camera.PictureSourceType.CAMERA);
            }
          },
          {
            text: this.translate.instant('GAL_LABEL'),
            cssClass: 'gallery_button',
            icon: 'images',
            handler: () => {
              this.showCamera(this.camera.PictureSourceType.SAVEDPHOTOALBUM);
            }
          },
          {
            text: this.translate.instant('FUEL_LABEL8'),
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }
        ]
      });
      await actionSheet.present();
    } else {
      this.fileUpload(ev);
    }
  }
  showCamera(sType) {
    const CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL, // this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: sType
    };
    this.camera.getPicture(CameraOptions).then((imageData) => {
      const count = new Date().getTime();
      const linkImage = imageData;
      if (this.imageBase64) {
        this.imageBase64.push({
          base64Data: linkImage,
          filename: 'DIimage' + count + '.jpeg'
        });
      } else {
        this.imageBase64 = [];
        this.imageBase64.push({
          base64Data: linkImage,
          filename: 'DIimage' + count + '.jpeg'
        });
      }
      this.damageModel.attachments = this.imageBase64;
    }, (err) => {
      // Handle error
    });
  }
  onDrop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length > 0)
      this.fileUpload(event);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
  
  fileUpload(ev) {
    let file: File;
    if (ev.type === 'drop')
      file = ev.dataTransfer.files[0];
    else
      file = ev.type === 'change' ? ev.target.files[0] : ev.target.control.files[0];
    this.insertFiles(file);
  }
  fileUploadMaster(ev) {
    const file = ev.type === 'change' ? ev.target.files[0] : ev.target.control.files[0];
    this.insertFiles(file);
  }
  async insertFiles(file) {
    if (file) {
      if (this.validFileType(file)) {
        this.isInvalidFileType = false;
        if (this.isValidSize(file.size)) {
          this.isInvalidFileSize = false;
          const data = await this.toBase64(file) as string;
          if (this.imageBase64) {
            this.imageBase64.push({
              base64Data: data,
              filename: file.name
            });
          } else {
            this.imageBase64 = [];
            this.imageBase64.push({
              base64Data: data,
              filename: file.name
            });
          }
          this.damageModel.attachments = this.imageBase64;
        } else {
          this.isInvalidFileSize = true;
          this.invalidSizeName = file.name;
        }
      } else {
        this.isInvalidFileType = true;
        this.invalidTypeName = file.name;
      }
    }
  }
  removeFile(filename) {
    this.imageBase64.forEach((fc, index) => {
      if (fc.filename === filename) {
        // this.damageModel.attachments.splice(index, 1);
        this.imageBase64.splice(index, 1);
      }
    });
    this.damageModel.attachments = this.imageBase64;
  }
  onEnterKey(e) {
    if (e.keyCode === 13) {
      const activeElement = document.activeElement as HTMLElement;
      if (activeElement != null && activeElement.blur) {
        activeElement.blur();
      }
    }
  }
  validFileType(file) {
    return this.fileTypes.includes(file.type);
  }
  returnFileSize(nbr) {
    if (nbr < 1024) {
      return nbr + 'bytes';
    } else if (nbr >= 1024 && nbr < 1048576) {
      return (nbr / 1024).toFixed(1) + 'KB';
    } else if (nbr >= 1048576) {
      return (nbr / 1048576).toFixed(1) + 'MB';
    }
  }
  isValidSize(nbr) {
    if (nbr > 52428800) {
      return false;
    } else {
      return true;
    }
  }
  toggleValues(fieldName, val) {
    if (fieldName === 'CC') {
      if (this.damageModel.euromaster.commercialCustomer === null || this.damageModel.euromaster.commercialCustomer) {
        this.damageModel.euromaster.privateCustomer = false;
        this.damageModel.euromaster.commercialCustomer = true;
      } else {
        this.damageModel.euromaster.privateCustomer = true;
        this.damageModel.euromaster.commercialCustomer = false;
      }
    } else {
      if (this.damageModel.euromaster.privateCustomer === null || this.damageModel.euromaster.privateCustomer) {
        this.damageModel.euromaster.commercialCustomer = false;
        this.damageModel.euromaster.privateCustomer = true;
      } else {
        this.damageModel.euromaster.commercialCustomer = true;
        this.damageModel.euromaster.privateCustomer = false;
      }
    }
    this.damageModel.euromaster.privateCustomer = this.damageModel.euromaster.commercialCustomer ? false : true;
  }

  sanitizeInput(input: string): string {
    const element = this.elementRef.nativeElement;
    element.innerHTML = input;
    const sanitizedInput = element.textContent;
    element.innerHTML = '';
    return sanitizedInput;
  }
  getTruncatedFilename(name: string): string {
    const maxLength = 10; 
    const dotIndex = name.lastIndexOf('.');
    if (dotIndex === -1 || name.length <= maxLength) {
      return name;
    }
  
    const ext = name.slice(dotIndex);
    const basename = name.slice(0, dotIndex);
    const shortBase = basename.slice(0, maxLength - ext.length - 3); 
    return `${shortBase}...${ext}`;
  }
  resetValidation(form, field, isSet) {
    const htmlCtrl = this[form].get(field);
    if (isSet) {
      htmlCtrl.setValidators([Validators.required, noWhitespaceValidator()]);
    } else {
      htmlCtrl.clearValidators();
      htmlCtrl.setValue('');
    }
    htmlCtrl.updateValueAndValidity();
  }
   
}
